var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18290_74609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88437 0.365625C8.39687 -0.121875 7.60625 -0.121875 7.11562 0.365625L0.365625 7.11562C-0.121875 7.60313 -0.121875 8.39375 0.365625 8.88437L7.11562 15.6344C7.60313 16.1219 8.39375 16.1219 8.88437 15.6344L15.6344 8.88437C16.1219 8.39687 16.1219 7.60625 15.6344 7.11562L8.88437 0.365625Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18290_74609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond-icon.c21c51a71dfbbb52b7c09b282b7cacab.svg";
export { ForwardRef as ReactComponent };